// Copyright (c) 2022 by Move Closer

import { ThemeRegistry } from '../../../../dsl/composables'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface BenefitsBarProps {
  theme: BenefitBarTheme
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export enum BenefitBarTheme {
  Default = '',
  Grey = 'grey'
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const benefitsBarClassRegistry: ThemeRegistry<string> = {
  [BenefitBarTheme.Default]: '',
  [BenefitBarTheme.Grey]: '--grey'
}
